import { NetworkStatus, useQuery } from "@apollo/client";

import FormLoading from "components/form/components/loading";
import Banner from "ds/components/Banner";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { TerraformWorkflowTool } from "types/generated";
import ModuleVersionInstructionsDrawerContent from "views/Account/Module/Version/components/InstructionsDrawer/Content";

import { GET_VERSION_INSTRUCTION } from "./gql";

type ModuleVersionInstructionsDrawerProps = {
  moduleId: string;
  moduleName: string;
  versionNumber: string;
  moduleSource: string;
  workflowTool: TerraformWorkflowTool;
};

const ModuleVersionInstructionsDrawer = createDrawer(
  ({
    moduleId,
    moduleName,
    versionNumber,
    moduleSource,
    workflowTool,
  }: ModuleVersionInstructionsDrawerProps) => {
    const { loading, data, networkStatus } = useQuery(GET_VERSION_INSTRUCTION, {
      variables: {
        moduleId,
        id: versionNumber,
      },
    });

    return (
      <DrawerSimple variant="wide">
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Instructions" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          {loading && networkStatus === NetworkStatus.loading && <FormLoading />}
          {!data?.module?.version && !loading && (
            <Banner variant="warning">No version data found.</Banner>
          )}

          {data?.module.version && (
            <ModuleVersionInstructionsDrawerContent
              inputs={data.module.version?.metadata?.root.inputs}
              moduleName={moduleName}
              type="module"
              versionNumber={versionNumber}
              moduleSource={moduleSource}
              workflowTool={workflowTool}
            />
          )}
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showModuleVersionInstructionsDrawer = createDrawerTrigger(
  ModuleVersionInstructionsDrawer
);
